export const getWindowHeight = () => {
  if (window.visualViewport) {
    return window.visualViewport.height + window.visualViewport.offsetTop
  }

  return window.innerHeight
}
